<template>
	<el-dialog title="手动接入" :visible.sync="dialogTableVisibles" :before-close="handleClose">
		<!--转接弹窗-->
		<div class="model-search">
			<el-dropdown class="dropmenu" @command="handleCommand">
				<el-button type>
					{{selectName}}
					<i class="el-icon-arrow-down el-icon--right"></i>
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item
						:command="item.key"
						:key="index"
						v-for="(item,index) in dropArr"
					>{{item.name}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<el-input placeholder="请输入内容" v-model="search" clearable class="search_box">
				<input type="text" autocomplete="off" placeholder="请输入内容" />
			</el-input>
		</div>
		<el-table
			:data="datas.filter(data => !search || data[selectKey].toLowerCase().includes(search.toLowerCase()))"
			height="500"
		>
			<el-table-column property="nickName" label="昵称" width="200"></el-table-column>
			<el-table-column property="mobile" label="手机"></el-table-column>
			<el-table-column property="channelName" label="访问渠道"></el-table-column>
			<el-table-column label="等待时间">
				<template slot-scope="scope">
					<timer :name="scope.row.waitingTime" autoStart :defaultVal="scope.row.waitingTime" />
				</template>

				<!-- <timer autoStart :defaultVal="{{scope.row.waitingTime}}" /> -->
			</el-table-column>
			<el-table-column property="content" label="客服内容"></el-table-column>
			<el-table-column property label="接入">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="onAccess(scope.$index, scope.row)">接入</el-button>
				</template>
			</el-table-column>
		</el-table>
	</el-dialog>
</template>
<script>
import timer from './timer'
export default {
	name: 'manualAccess',
	data() {
		return {
			dialogTableVisibles: false,
			datas: [],
			input10: '',
			selectName: '渠道',
			selectKey: 'channelName',
			dropArr: [
				{
					key: 'mobile',
					name: '手机号'
				},
				{
					key: 'channelName',
					name: '渠道'
				}
			],
			search: ''
		}
	},
	props: {
		data: {
			type: Array,
			default: []
		},
		dialogTableVisible: {
			type: Boolean,
			default: false
		}
	},
	components: { timer },

	watch: {
		dialogTableVisible: function(val) {
			this.dialogTableVisibles = val
		},
		data: function(val) {
			console.log(val)
			this.datas = val
		},
		search: function(val) {
			console.log(val)
		}
	},
	methods: {
		handleClose: function(val) {
			this.$emit('tranHandleClose', false)
		},
		onAccess: function(index, row) {
			this.$emit('onAccess', row.cousultId, row.channelId, row.awaitKey) //点击接入
		},
		handleCommand: function(e) {
			let str = this.dropArr.find(d => d.key == e)
			this.selectKey = str.key
			this.selectName = str.name
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/customer/talks/manualAccess.vue